/**
 * Frontend authentication module.
 * Handles Telegram initData auth flow and token management.
 */

import { getInitData } from './telegram';
import { apiPost, setAuthToken } from './api';

const STORAGE_KEY = 'intel-bot-token';

interface AuthResponse {
  token: string;
  user: {
    chatId: string;
    firstName: string;
  };
}

/**
 * Authenticate via Telegram initData.
 * Returns user info on success, null on failure.
 */
export async function authenticate(): Promise<{ chatId: string; name: string } | null> {
  const initData = getInitData();
  if (!initData) return null;

  try {
    const { token, user } = await apiPost<AuthResponse>('/auth', { initData });
    setAuthToken(token);
    localStorage.setItem(STORAGE_KEY, token);
    return { chatId: user.chatId, name: user.firstName };
  } catch {
    return null;
  }
}

/**
 * Get stored JWT token from localStorage.
 */
export function getStoredToken(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

/**
 * Clear stored auth token.
 */
export function clearStoredToken(): void {
  localStorage.removeItem(STORAGE_KEY);
}
